import { useQuery } from '@apollo/client'
import { useMemo } from 'react'

import {
  IPrepSettingScopesType,
  IScopeOption,
  listPrepSettingScopes,
} from '../gql'

const usePrepSettingScopes = () => {
  const { data, loading, error } = useQuery<IPrepSettingScopesType>(
    listPrepSettingScopes,
  )

  const scopes = useMemo(
    (): IScopeOption[] => data?.listPrepSettingScopes?.nodes ?? [],
    [data],
  )

  const scopeById = useMemo(
    () =>
      scopes.reduce(
        (acc, scope) => ({ ...acc, [scope.locationGroupId]: scope }),
        {} as Record<number, IScopeOption>,
      ),
    [scopes],
  )

  return { scopes, scopeById, loading, error }
}

export default usePrepSettingScopes
